import React from 'react';
import { Input, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';
import { PAINTING_TITLE_INPUT_LABEL, PAINTING_TITLE_INPUT_TEST_ID, PAINTING_DESCRIPTION_INPUT_LABEL, PAINTING_DESCRIPTION_INPUT_TEST_ID, PAINTING_COLLECTION_INPUT_LABEL, PAINTING_COLLECTION_INPUT_TEST_ID, PAINTING_MUSEUM_INPUT_LABEL, PAINTING_MUSEUM_INPUT_TEST_ID, PAINTING_LOCATION_INPUT_LABEL, PAINTING_LOCATION_INPUT_TEST_ID, PAINTING_YEAR_INPUT_LABEL, PAINTING_YEAR_INPUT_TEST_ID } from '../../forms/painting/constants';

/** painting citing section id and testId */
export var PAINTING_SECTION_ID = 'painting-citing-section';
export var PAINTING_SECTION_TEST_ID = 'painting-section-test-id';
export var PaintingCiting = function PaintingCiting() {
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: PAINTING_SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(PAINTING_SECTION_ID, "-label"),
    dataTestId: PAINTING_SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "painting.title",
    labelText: PAINTING_TITLE_INPUT_LABEL,
    "data-test": PAINTING_TITLE_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "painting.description",
    labelText: PAINTING_DESCRIPTION_INPUT_LABEL,
    "data-test": PAINTING_DESCRIPTION_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "painting.collection",
    labelText: PAINTING_COLLECTION_INPUT_LABEL,
    "data-test": PAINTING_COLLECTION_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "painting.museum",
    labelText: PAINTING_MUSEUM_INPUT_LABEL,
    "data-test": PAINTING_MUSEUM_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "painting.location",
    labelText: PAINTING_LOCATION_INPUT_LABEL,
    "data-test": PAINTING_LOCATION_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "painting.year",
    labelText: PAINTING_YEAR_INPUT_LABEL,
    "data-test": PAINTING_YEAR_INPUT_TEST_ID
  }));
};